<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 14:27:03
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-11-07 15:31:56
-->
<template>
  <div class="news">
    <div class="news-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/news/bj.png')" alt="" srcset="">
      <div class="news-bj-txt">
        <div class="ui-title">{{$t('news.title')}}</div>
        <div class="ui-des">{{$t('news.des')}}</div>
      </div>
    </div>
    <div class="news-content">
      <div class="news-list-box news-reveal-box">
        <a class="news-list-item news-reveal-item" :href="item.url" target="_blank" v-for="(item,index) in $t('news.reveal')" :key="index">
          <van-image class="news-list-item-img news-reveal-item-img" :src="item.poster" :title="item.title" fit="cover"></van-image>
          <div class="news-list-item-box textj">
            <p class="news-list-item-title news-reveal-item-title" :title="item.title" v-html="item.title"></p>
            <p class="news-list-item-des" v-html="item.des"></p>
            <div class="news-list-item-bottom flex justify_content_between">
              <div class="news-list-item-time">{{item.time}}</div>
              <svg-icon class="news-list-item-next" icon-class="jiantou" />
            </div>
          </div>
        </a>
      </div>
      <van-list class="news-list-box"
        :loading="loading"
        :finished="noMore"
        :finished-text="$t('news.noMore')"
        @load="loadNews">
          <a v-for="(item,index) in $t('news.dynamicData').slice(0, limit)" :key="index" :class="['news-list-item']" :href="item.url" target="_blank">
            <div class="news-list-item-wrap flex">
              <div class="news-list-item-img">
                <van-image :src="item.poster" :title="item.title" fit="cover"></van-image>
              </div>
              <div class="flex_1 news-list-item-box">
                <p class="news-list-item-title" v-html="item.title"></p>
                <p class="news-list-item-des" v-html="item.des"></p>
                <div class="news-list-item-bottom flex justify_content_between">
                  <div class="news-list-item-time">{{item.time}}</div>
                  <svg-icon class="news-list-item-next" icon-class="jiantou" />
                </div>
              </div>
            </div>
          </a>
      </van-list>
    </div>
  </div>
</template>

<script>
import { throttle } from '@/utils'
export default {
  name: 'news',
  data () {
    return {
      limit: 10,
      loading: false
    }
  },
  computed: {
    noMore () {
      return this.limit >= this.$t('news.dynamicData').length
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.newsListElements = Array.from(document.getElementsByClassName('news-list-item'))
    this.removeListClass()
    this.scrollChange = throttle(this.scrollChange)
    this.scrollChange()
    window.addEventListener('scroll', this.scrollChange, true)
  },
  methods: {
    loadNews () {
      this.loading = true
      const timer = setTimeout(() => {
        clearTimeout(timer)
        this.limit += 20
        this.$nextTick(() => {
          this.newsListElements = Array.from(document.getElementsByClassName('news-list-item'))
        })
        this.loading = false
      }, 1000)
    },
    scrollChange (evt) {
      for (let i = 0; i < this.newsListElements.length; i++) {
        const elem = this.newsListElements[i]
        if (!elem.classList.contains('show')) {
          if (this.isElemVisible(elem)) {
            elem.classList.add('show')
            // this.newsListElements.splice(i, 1) // 只让他执行一次
          }
        }
      }
    },
    removeListClass () {
      for (let i = 0; i < this.newsListElements.length; i++) {
        const elem = this.newsListElements[i]
        elem.classList.remove('show')
      }
    },
    isElemVisible (el) {
      const rect = el.getBoundingClientRect()
      const elemTop = rect.top
      const elemBottom = rect.bottom
      return elemTop < window.innerHeight && elemBottom >= 0
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollChange, true)
  }
}
</script>

<style lang="less" scoped>
@import '../../../styles/globalVars.less';
.m .news {
  .news-bj {
    position: relative;
    img{
      margin-bottom: -3px;
    }
    .news-bj-txt {
      position: absolute;
      right: 30px;
      bottom: 40px;
    }
  }
  .news-content {
    padding: 30px;
    .news-list-box {
      color: #333333;
      line-height: 26px;
      padding-bottom: 30px;
      font-size: 26px;
      line-height: 38px;
      overflow: auto;
      .news-list-item {
        overflow: hidden;
        display: block;
        .news-list-item-wrap {
          padding: 30px 0;
          border-bottom: 1px solid rgba(151, 151, 151, 0.2);
          -webkit-transform: translate3d(0, 100%, 0);
          transform: translate3d(0, 100%, 0);
          -moz-transform: translate3d(0, 100%, 0);
          -ms-transform: translate3d(0, 100%, 0);
          -o-transform: translate3d(0, 100%, 0);
        }
        &.show .news-list-item-wrap{
          -webkit-transform: translateZ(0);
          transform: translateZ(0);
          -moz-transform: translateZ(0);
          -ms-transform: translateZ(0);
          -o-transform: translateZ(0);
          transition: all 1s;
        }
        .news-list-item-img {
          width: 285px;
          height: 200px;
          overflow: hidden;
          .van-image {
            width: 100%;
            height: 100%;
          }
          &:hover .van-image {
            transform: scale(1.1);
          }
        }
        .news-list-item-box {
          padding-left: 32px;
          position: relative;
        }
        .news-list-item-title {
          font-weight: bold;
          line-height: 40px;
          margin-bottom: 10px;
          color: #333333;
          display: block;
          .textoverflow(2);
        }
        .news-list-item-des {
          color: rgba(51, 51, 51, 0.7);
          .textoverflow(2);
          word-break: break-word;
        }
        .news-list-item-bottom {
          position: absolute;
          bottom: 0;
          width: calc(100% - 32px);
          line-height: 32px;
          color: rgba(51, 51, 51, 0.8);
          .news-list-item-next{
            color: #C2C2C2;
            font-size: 32px;
          }
        }
      }
    }
    .news-reveal-box {
      .news-reveal-item {
        position: relative;
        padding: 30px 0 70px 0;
        border-bottom: 1px solid rgba(151, 151, 151, 0.2);
        .news-reveal-item-img {
          width: 100%;
          height: auto;
          object-fit: cover;
        }
        .news-list-item-des {
          .textoverflow(3);
        }
        .news-list-item-box {
          padding: 22px 0 0 0;
        }
        .news-list-item-bottom {
          bottom: -50px;
        }
      }
    }
  }
}
</style>
